module.exports = __webpack_public_path__ + "static/salary_8.c9a0fc84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/salary/assets/2x/salary_8.jpg
// module id = 405
// module chunks = 32503283977284